<template>
  <b-form-checkbox-group
    v-if="multiple && !dropdown"
    :checked="computedValue"
    :disabled="disabled"
    stacked
    :state="error ? false : null"
    @change="valueChanged($event)">
    <template v-for="o in computedOptions">
      <b-form-checkbox :value="o && o.value">
        {{ o && o.text }}
        <i
          v-if="o.help"
          class="fa fa-fw fa-question-circle text-info"
          v-b-tooltip :title="o.help"></i>
        <tag-list v-if="o.tags && o.tags.length" :value="o.tags" />
      </b-form-checkbox>
    </template>
  </b-form-checkbox-group>
  <b-form-select
    v-else-if="multiple && dropdown"
    :selected="computedValue"
    :options="computedOptions"
    :disabled="disabled"
    :state="error ? false : null"
    @input="valueChanged($event)">
  </b-form-select>
  <b-form-radio-group
    v-else-if="!multiple && !dropdown"
    :checked="computedValue"
    :options="computedOptions"
    :disabled="disabled"
    :state="error ? false : null"
    @input="valueChanged($event)">
  </b-form-radio-group>
  <b-form-select
    v-else
    :value="computedValue"
    :options="computedOptions"
    :disabled="disabled"
    :state="error ? false : null"
    @input="valueChanged($event)">
  </b-form-select>
</template>
<script>
import FormFieldMixin from 'vue-forms/mixins/FormFieldMixin';
import OptionsFieldMixin from 'vue-forms/mixins/OptionsFieldMixin';
import isEqual from 'lodash/isEqual';
import Multiselect from 'vue-multiselect';

export default {
  mixins: [ FormFieldMixin, OptionsFieldMixin ],

  components: { Multiselect },

  computed: {
    computedOptions() {
      if (this.item2option) {
        return this.options.map(item => this.item2option(item));
      }
      return this.options;
    },

    computedValue() {
      if (this.value2id) {
        if (this.value === undefined || this.value === null) {
          return this.value;
        }

        if (Array.isArray(this.value)) {
          return this.value.map(item => item && this.value2id(item));
        } else {
          return this.value2id(this.value);
        }
      }
      return this.value;
    }
  },

  methods: {
    shouldEmit(v) {
      const eq = isEqual(v, this.value);

      /*
      console.log('v', v);
      console.log('this.value', this.value);
      console.log('equal', eq);
      */

      return !eq;
    },

    valueChanged(v) {
      let ret = v;
      if (this.id2value) {
        if (v === undefined || v === null) {
          ret = v;
        } else if (Array.isArray(v)) {
          ret = v.map(item => this.id2value(item));
        } else {
          ret = this.id2value(v);
        }
      }
      if (this.shouldEmit(ret)) {
        this.$emit('input', ret);
      }
    }
  }
};
</script>
